export const getItemIdFromUri = (path = ''): string | null => {
    const regexp = /([fajv]_\d+)/;
    const itemId = path.match(regexp);
    if (Array.isArray(itemId) && itemId.length > 0) {
        return itemId[0];
    }
    return null;
};
